import { useCallback, useEffect, useState } from "react";

import { deepEqual } from "Utilities/deepEqual";

export default function useInitialActiveFilters() {
  const [initialActiveFilters, setInitialActiveFilters] = useState(undefined);
  const [activeFiltersHaveChanged, setActiveFiltersHaveChanged] =
    useState(false);

  const getActiveFilters = useCallback(() => {
    const filters = window?.fnReactBus?.filtersPanel?.filters;

    if (!filters) {
      setTimeout(() => getActiveFilters(), 100);
      return;
    }

    const activeFilter =
      window.fnReactBus?.filtersPanel?.filterBuilder?.buildRequest()?.and?.[0]
        ?.or?.[0]?.and;
    return activeFilter;
  }, []);

  const getInitialFilters = () => {
    if (initialActiveFilters) return;

    const activeFilters = getActiveFilters();
    if (!activeFilters) return;
    setInitialActiveFilters(activeFilters);
  };

  const activeFilters = getActiveFilters();

  const determineChange = useCallback(() => {
    if (!initialActiveFilters) return;
    const haveChanged = !deepEqual(activeFilters, initialActiveFilters);
    setActiveFiltersHaveChanged(haveChanged);
  }, [activeFilters, initialActiveFilters]);

  useEffect(() => {
    determineChange();
  }, [activeFilters, determineChange]);

  useEffect(getInitialFilters, [getInitialFilters]);

  // useEffect(determineChange, )

  return { activeFiltersHaveChanged };
}
